


















import { Vue, Component, Emit, Prop } from 'nuxt-property-decorator'

@Component({})
export default class Checkbox extends Vue {
  @Prop(Boolean) value!: boolean

  @Emit('input')
  onChange(event) {
    return event.target.value
  }

  @Emit('input')
  toggle() {
    return !this.value
  }
}
